var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.status === 0
      ? _c(
          "div",
          { staticStyle: { display: "flex", "align-items": "center" } },
          [
            _c("img", {
              staticStyle: { width: "24px", height: "24px" },
              attrs: { src: require("@/assets/img/ic_waitbook.png"), alt: "" },
            }),
            _c(
              "span",
              { staticStyle: { color: "#272E3B", "margin-left": "5px" } },
              [_vm._v(_vm._s(_vm.showName(_vm.bookingList, _vm.status)))]
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.status === 1
      ? _c(
          "div",
          { staticStyle: { display: "flex", "align-items": "center" } },
          [
            _c("img", {
              staticStyle: { width: "24px", height: "24px" },
              attrs: { src: require("@/assets/img/ic_booksure.png"), alt: "" },
            }),
            _c(
              "span",
              { staticStyle: { color: "#272E3B", "margin-left": "5px" } },
              [_vm._v(_vm._s(_vm.showName(_vm.bookingList, _vm.status)))]
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.status === 3
      ? _c(
          "div",
          { staticStyle: { display: "flex", "align-items": "center" } },
          [
            _c("img", {
              staticStyle: { width: "24px", height: "24px" },
              attrs: {
                src: require("@/assets/img/ic_cancelbook.png"),
                alt: "",
              },
            }),
            _c(
              "span",
              { staticStyle: { color: "#272E3B", "margin-left": "5px" } },
              [_vm._v(_vm._s(_vm.showName(_vm.bookingList, _vm.status)))]
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.status === 4
      ? _c(
          "div",
          { staticStyle: { display: "flex", "align-items": "center" } },
          [
            _c("img", {
              staticStyle: { width: "24px", height: "24px" },
              attrs: { src: require("@/assets/img/ic_suoding.png"), alt: "" },
            }),
            _c(
              "span",
              { staticStyle: { color: "#272E3B", "margin-left": "5px" } },
              [_vm._v(_vm._s(_vm.showName(_vm.bookingList, _vm.status)))]
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.status === 5
      ? _c(
          "div",
          { staticStyle: { display: "flex", "align-items": "center" } },
          [
            _c("img", {
              staticStyle: { width: "24px", height: "24px" },
              attrs: { src: require("@/assets/img/ic_jiesuo.png"), alt: "" },
            }),
            _c(
              "span",
              { staticStyle: { color: "#272E3B", "margin-left": "5px" } },
              [_vm._v(_vm._s(_vm.showName(_vm.bookingList, _vm.status)))]
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.status === 6
      ? _c(
          "div",
          { staticStyle: { display: "flex", "align-items": "center" } },
          [
            _c("img", {
              staticStyle: { width: "24px", height: "24px" },
              attrs: { src: require("@/assets/img/ic_waitbook.png"), alt: "" },
            }),
            _c(
              "span",
              { staticStyle: { color: "#272E3B", "margin-left": "5px" } },
              [_vm._v(_vm._s(_vm.showName(_vm.bookingList, _vm.status)))]
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.status === 7
      ? _c(
          "div",
          { staticStyle: { display: "flex", "align-items": "center" } },
          [
            _c("img", {
              staticStyle: { width: "24px", height: "24px" },
              attrs: { src: require("@/assets/img/ic_waitbook.png"), alt: "" },
            }),
            _c(
              "span",
              { staticStyle: { color: "#272E3B", "margin-left": "5px" } },
              [_vm._v(_vm._s(_vm.showName(_vm.bookingList, _vm.status)))]
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.status === 8
      ? _c(
          "div",
          { staticStyle: { display: "flex", "align-items": "center" } },
          [
            _c("img", {
              staticStyle: { width: "24px", height: "24px" },
              attrs: { src: require("@/assets/img/ic_editbook.png"), alt: "" },
            }),
            _c(
              "span",
              { staticStyle: { color: "#272E3B", "margin-left": "5px" } },
              [_vm._v(_vm._s(_vm.showName(_vm.bookingList, _vm.status)))]
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.status === 9
      ? _c(
          "div",
          { staticStyle: { display: "flex", "align-items": "center" } },
          [
            _c("img", {
              staticStyle: { width: "24px", height: "24px" },
              attrs: {
                src: require("@/assets/img/ic_quxiaoshenqing.png"),
                alt: "",
              },
            }),
            _c(
              "span",
              { staticStyle: { color: "#272E3B", "margin-left": "5px" } },
              [_vm._v(_vm._s(_vm.showName(_vm.bookingList, _vm.status)))]
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.status === 10
      ? _c(
          "div",
          { staticStyle: { display: "flex", "align-items": "center" } },
          [
            _c("img", {
              staticStyle: { width: "24px", height: "24px" },
              attrs: { src: require("@/assets/img/ic_caogao.png"), alt: "" },
            }),
            _c(
              "span",
              { staticStyle: { color: "#272E3B", "margin-left": "5px" } },
              [_vm._v(_vm._s(_vm.showName(_vm.bookingList, _vm.status)))]
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.status === 11
      ? _c(
          "div",
          { staticStyle: { display: "flex", "align-items": "center" } },
          [
            _c("img", {
              staticStyle: { width: "24px", height: "24px" },
              attrs: { src: require("@/assets/img/ic_shenqing.png"), alt: "" },
            }),
            _c(
              "span",
              { staticStyle: { color: "#272E3B", "margin-left": "5px" } },
              [_vm._v(_vm._s(_vm.showName(_vm.bookingList, _vm.status)))]
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.status === 13
      ? _c(
          "div",
          { staticStyle: { display: "flex", "align-items": "center" } },
          [
            _c("img", {
              staticStyle: { width: "24px", height: "24px" },
              attrs: {
                src: require("@/assets/img/ic_bulushenqing.png"),
                alt: "",
              },
            }),
            _c(
              "span",
              { staticStyle: { color: "#272E3B", "margin-left": "5px" } },
              [_vm._v(_vm._s(_vm.showName(_vm.bookingList, _vm.status)))]
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.status === 14
      ? _c(
          "div",
          { staticStyle: { display: "flex", "align-items": "center" } },
          [
            _c("img", {
              staticStyle: { width: "24px", height: "24px" },
              attrs: {
                src: require("@/assets/img/ic_bulucaogao.png"),
                alt: "",
              },
            }),
            _c(
              "span",
              { staticStyle: { color: "#272E3B", "margin-left": "5px" } },
              [_vm._v(_vm._s(_vm.showName(_vm.bookingList, _vm.status)))]
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.status === 15
      ? _c(
          "div",
          { staticStyle: { display: "flex", "align-items": "center" } },
          [
            _c("img", {
              staticStyle: { width: "24px", height: "24px" },
              attrs: { src: require("@/assets/img/ic_caidan.png"), alt: "" },
            }),
            _c(
              "span",
              { staticStyle: { color: "#272E3B", "margin-left": "5px" } },
              [_vm._v(_vm._s(_vm.showName(_vm.bookingList, _vm.status)))]
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.status === 16
      ? _c(
          "div",
          { staticStyle: { display: "flex", "align-items": "center" } },
          [
            _c("img", {
              staticStyle: { width: "24px", height: "24px" },
              attrs: {
                src: require("@/assets/img/ic_fenbaofenchu.png"),
                alt: "",
              },
            }),
            _c(
              "span",
              { staticStyle: { color: "#272E3B", "margin-left": "5px" } },
              [_vm._v(_vm._s(_vm.showName(_vm.bookingList, _vm.status)))]
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.status === 17
      ? _c(
          "div",
          { staticStyle: { display: "flex", "align-items": "center" } },
          [
            _c("img", {
              staticStyle: { width: "24px", height: "24px" },
              attrs: {
                src: require("@/assets/img/ic_fenbaofenchu.png"),
                alt: "",
              },
            }),
            _c(
              "span",
              { staticStyle: { color: "#272E3B", "margin-left": "5px" } },
              [_vm._v(_vm._s(_vm.showName(_vm.bookingList, _vm.status)))]
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.status === 18
      ? _c(
          "div",
          { staticStyle: { display: "flex", "align-items": "center" } },
          [
            _c("img", {
              staticStyle: { width: "24px", height: "24px" },
              attrs: {
                src: require("@/assets/img/ic_fenbaofenchuclose.png"),
                alt: "",
              },
            }),
            _c(
              "span",
              { staticStyle: { color: "#272E3B", "margin-left": "5px" } },
              [_vm._v(_vm._s(_vm.showName(_vm.bookingList, _vm.status)))]
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.status === 19
      ? _c(
          "div",
          { staticStyle: { display: "flex", "align-items": "center" } },
          [
            _c("img", {
              staticStyle: { width: "24px", height: "24px" },
              attrs: { src: require("@/assets/img/ic_caidan.png"), alt: "" },
            }),
            _c(
              "span",
              { staticStyle: { color: "#272E3B", "margin-left": "5px" } },
              [_vm._v(_vm._s(_vm.showName(_vm.bookingList, _vm.status)))]
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.status === 20
      ? _c(
          "div",
          { staticStyle: { display: "flex", "align-items": "center" } },
          [
            _c("img", {
              staticStyle: { width: "24px", height: "24px" },
              attrs: {
                src: require("@/assets/img/ic_fenbaofenchu.png"),
                alt: "",
              },
            }),
            _c(
              "span",
              { staticStyle: { color: "#272E3B", "margin-left": "5px" } },
              [_vm._v(_vm._s(_vm.showName(_vm.bookingList, _vm.status)))]
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.status === 21
      ? _c(
          "div",
          { staticStyle: { display: "flex", "align-items": "center" } },
          [
            _c("img", {
              staticStyle: { width: "24px", height: "24px" },
              attrs: { src: require("@/assets/img/ic_caidan.png"), alt: "" },
            }),
            _c(
              "span",
              { staticStyle: { color: "#272E3B", "margin-left": "5px" } },
              [_vm._v(_vm._s(_vm.showName(_vm.bookingList, _vm.status)))]
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.status === 22
      ? _c(
          "div",
          { staticStyle: { display: "flex", "align-items": "center" } },
          [
            _c("img", {
              staticStyle: { width: "24px", height: "24px" },
              attrs: {
                src: require("@/assets/img/ic_fenbaofenchu.png"),
                alt: "",
              },
            }),
            _c(
              "span",
              { staticStyle: { color: "#272E3B", "margin-left": "5px" } },
              [_vm._v(_vm._s(_vm.showName(_vm.bookingList, _vm.status)))]
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }